let buttons = {
  title: 'lite editor',
  toolbarGroups: [
    {name: 'styles', groups: ['styles', 'links', 'colors']},
    {name: 'insert', groups: ['insert', 'embed']},
    {name: 'basicstyles', groups: ['basicstyles', 'cleanup', 'nbsp']},
    {name: 'paragraph', groups: ['list', 'indent', 'align']},
  ],
  removePlugins: 'specialchar,links,copyformatting,magicline,undo',
  removeButtons: 'About,Anchor,Subscript,Superscript,Styles,BGColor,h4,Image,HorizontalRule,Smiley,PageBreak,Iframe',
  extraAllowedContent: 'span(*)[id];div(*)[id];p(*)[id];h1(*)[id];h2(*)[id];h3(*)[id];h4(*)[id];h5(*)[id];ol(*)[id];ul(*)[id];li(*)[id]',
  extraPlugins: 'font,justify,colorspanel,nbsp,embed,embedbase,sourcearea',
};

module.exports.config = {
  'customConfig': '',
  'language': 'en',
  'linkShowAdvancedTab': false,
  'format_tags': 'p;h1;h2;h3',
  'colorspanel_foreStyle': {
    element: 'span',
    attributes: {'class': 'color'},
  },
  'forcePasteAsPlainText': true,
  'pasteFromWordRemoveFontStyles': true,
  'font_names': '',
  'contentsLangDirection': '',
  'linkDefaultProtocol': 'https://',
  'fillEmptyBlocks': false,
  'versionCheck': false,
  'embed_provider': '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
};

module.exports.fontSize = {
  'vmin': 'Default/none;1/1vmin;2/2vmin;3/3vmin;4/4vmin;5/5vmin;6/6vmin;7/7vmin;8/8vmin;9/9vmin;10/10vmin;11/11vmin;12/12vmin;13/13vmin;14/14vmin;15/15vmin;16/16vmin;',
  'px': 'Default/none;8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;48/48px;72/72px;',
};

module.exports.buttons = buttons;
